import React from 'react';
import { LocalPageTemplate } from '../components/LocalPageTemplate';
export function WebdesignDiemenPage() {
  return <LocalPageTemplate cityName="Diemen" region="Amstelland" introText="Professionele websites voor ondernemers in Diemen. Wij bouwen websites die jouw bedrijf laten groeien op de grens van Amsterdam." localContext="Diemen ligt direct naast Amsterdam en profiteert van de hoofdstedelijke dynamiek terwijl het een eigen karakter behoudt. Met het groeiende Holland Park als modern woon- en werkgebied en de nabijheid van Amsterdam Zuidoost en het AMC trekt Diemen steeds meer bedrijvigheid aan. Voor ondernemers in Diemen biedt een goede website de kans om zowel de lokale markt als het enorme Amsterdamse achterland te bedienen." nearbyLocations={[{
    name: 'Amsterdam',
    slug: 'amsterdam'
  }, {
    name: 'Ouder-Amstel',
    slug: 'ouder-amstel'
  }, {
    name: 'Amstelveen',
    slug: 'amstelveen'
  }, {
    name: 'Gooise Meren',
    slug: 'gooise-meren'
  }]} faqs={[{
    q: 'Wat kost een website laten maken in Diemen?',
    a: 'Een professionele bedrijfswebsite in Diemen start vanaf €1.500. De investering hangt af van je wensen, van een eenvoudige bedrijfspresentatie tot een uitgebreide site met webshop. We geven altijd vooraf een transparante offerte.'
  }, {
    q: 'Bouwen jullie ook websites voor bedrijven in Holland Park?',
    a: 'Ja, Holland Park is een groeiend zakelijk gebied en wij bouwen websites voor de diverse bedrijven die zich hier vestigen. Van startups tot gevestigde dienstverleners. We zorgen voor een professionele online aanwezigheid.'
  }]} data-id="element-1822" data-mp="1mt1ovazz6dxm" />;
}